import { Component, ElementRef, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { PriceTypeService } from '~shared/modules/price-type-toggler/services';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  ACCEPT_COOKIES_URL_QUERY,
  COMPASS_COOKIE_DISCLAIMER_CLASS,
  COMPASS_COOKIE_DISCLAIMER_TAG,
  COOKIE_BANNER_OVERLAY_CLASS
} from '~shared/modules/cookie-consent/constants/cookie-consent.constant';
import { AuthorizationStateType } from '~app/modules/authorization/constants/authorization.constant';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { createCookieExpiration } from '~shared/modules/price-type-toggler/utils/price-type-cookies.util';
import { PRICE_TYPE_EXPLANATION_COOKIE_NAME } from '~shared/modules/price-type-toggler/constants/cookie-name.constant';
import { CookieService } from '~shared/services/cookie.service';

@Component({
  selector: 'app-mobile-explanation-message',
  templateUrl: './mobile-explanation-message.component.html',
  styleUrls: ['./mobile-explanation-message.component.scss']
})
export class MobileExplanationMessageComponent {
  public PendingState = AuthorizationStateType.Pending;

  authState$ = this.authIdamStateService.state$;

  constructor(
    private elementRef: ElementRef,
    private priceTypeService: PriceTypeService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private authIdamStateService: AuthorizationIdamStateService,
    private cookieService: CookieService,
  ) {
  }

  closePriceTypeExplanation() {
    if (isPlatformBrowser(this.platformId)) {
      const expires = createCookieExpiration();
      this.cookieService.set(PRICE_TYPE_EXPLANATION_COOKIE_NAME, 'false', expires, '/');
      this.elementRef.nativeElement.remove();
    }
  }

  checkNewCookieDisclaimer() {
    if (isPlatformBrowser(this.platformId)) {
      const isNewCookiesDisclaimerAccepted = window.location.href.includes(ACCEPT_COOKIES_URL_QUERY);
      const isNewCookieDisclaimerVisible = this.document.querySelector(COMPASS_COOKIE_DISCLAIMER_TAG)
        .classList.contains(COMPASS_COOKIE_DISCLAIMER_CLASS);
      if (isNewCookiesDisclaimerAccepted && isNewCookieDisclaimerVisible) {
        this.document.querySelector(COMPASS_COOKIE_DISCLAIMER_TAG).classList.remove(COMPASS_COOKIE_DISCLAIMER_CLASS);
      }
    }
  }

  @HostListener('document:click', ['$event'])
  clickOut(event) {
    this.checkNewCookieDisclaimer();

    const onExplanationPopupClicked = this.elementRef.nativeElement.contains(event.target);
    const isCookieOverlayVisible = this.document.body.classList.contains(COOKIE_BANNER_OVERLAY_CLASS);
    const isNewCookieDisclaimerVisible = this.document.querySelector(COMPASS_COOKIE_DISCLAIMER_TAG)
      .classList.contains(COMPASS_COOKIE_DISCLAIMER_CLASS);

    if(!onExplanationPopupClicked && !isCookieOverlayVisible && !isNewCookieDisclaimerVisible) {
      this.closePriceTypeExplanation();
    }
  }

  switchPriceTypeToB2C() {
    this.priceTypeService.setPriceType(PriceTypes.b2c);
    this.closePriceTypeExplanation();
  }
}
